'use client';

import { forwardRef } from 'react';

import { AccordionProvider } from './contexts/accordion-context';
import { useAccordion, UseAccordionProps } from './hooks/use-accordion';

export interface AccordionProps extends UseAccordionProps {
	children: React.ReactNode;
}

export const Accordion = forwardRef<HTMLElement, AccordionProps>(function Accordion(
	props, 
	ref
) {
	const {
		Component,
		classNames,
		allowMultiple,
		expandedItemKeys,
		changeSelection,
		isAccordionItemExpanded,
		...otherProps
	} = useAccordion(props);

	return (
		<AccordionProvider
			allowMultiple={allowMultiple}
			expandedItemKeys={expandedItemKeys}
			changeSelection={changeSelection}
			isAccordionItemExpanded={isAccordionItemExpanded}
		>
			<Component
				ref={ref}
				className={classNames}
				{...otherProps}
			/>
		</AccordionProvider>
	);
});